function getPrefix(mediaType) {
  if (mediaType === 'video') return '视频';
  if (mediaType === 'audio') return '音频';
  return '图片';
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function renameOccurrences(text, renameMap) {
  let nextText = text || '';
  renameMap.forEach(({ from, to }) => {
    if (!from || from === to) return;
    nextText = nextText.replace(new RegExp(escapeRegExp(from), 'g'), to);
  });
  return nextText;
}

export function removeSubjectAssets({
  subject,
  subjects,
  prompt,
  referenceItems,
  firstFrameUrl,
  lastFrameUrl,
}) {
  const sourceUrl = subject?.sourceUrl || '';
  const remainingSubjects = (subjects || []).filter((item) => item.id !== subject?.id);
  const targetMediaType = subject?.mediaType;
  const targetPrefix = getPrefix(targetMediaType);
  const renameMap = [];

  let targetIndex = 1;
  const nextSubjects = remainingSubjects.map((item) => {
    if (item.mediaType !== targetMediaType) {
      return item;
    }

    const nextName = `${targetPrefix}${targetIndex}`;
    targetIndex += 1;

    if (item.name !== nextName) {
      renameMap.push({ from: item.name, to: nextName, sourceUrl: item.sourceUrl });
    }

    return {
      ...item,
      name: nextName,
    };
  });

  const promptWithoutRemovedSubject = (prompt || '').replaceAll(subject?.name || '', '');
  const renamedPrompt = renameOccurrences(promptWithoutRemovedSubject, renameMap);
  const nextReferenceItems = (referenceItems || [])
    .filter((item) => item.url !== sourceUrl)
    .map((item) => {
      const matchedRename = renameMap.find((rename) => rename.sourceUrl === item.url);
      return matchedRename ? { ...item, name: matchedRename.to } : item;
    });

  return {
    nextPrompt: renamedPrompt,
    nextReferenceItems,
    nextFirstFrameUrl: firstFrameUrl === sourceUrl ? '' : firstFrameUrl,
    nextLastFrameUrl: lastFrameUrl === sourceUrl ? '' : lastFrameUrl,
    nextSubjects: subjects ? nextSubjects : undefined,
  };
}
